// eslint-disable-next-line no-unused-vars
import React, { useEffect } from 'react';
import { showSpinnerOverlay } from '../../utility/helper';

export default function FallbackSpinner() {
  useEffect(() => {
    showSpinnerOverlay();
  }, []);

  return <></>;
}
